import getStore from '@state/store';
import React, { FunctionComponent, useContext } from 'react';
import { Provider, ReactReduxContext } from 'react-redux';

interface BaseProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reduxContext?: any;
}

export default function withRedux<T>(
  WrappedComponent: FunctionComponent<T>,
): FunctionComponent<T & Partial<BaseProps>> {
  const Output: FunctionComponent<T & Partial<BaseProps>> = (props) => {
    const { reduxContext, ...otherProps } = props;

    // Will be undefined if no Provider above in the tree
    const reduxContextValue = useContext(ReactReduxContext);

    if (reduxContextValue?.store) {
      // Already inside a Provider → just render wrapped component
      return <WrappedComponent {...(otherProps as T)} />;
    }

    // No store yet → create and wrap in Provider
    const store = getStore(reduxContext, WrappedComponent.displayName || WrappedComponent.name);
    return (
      <Provider store={store}>
        <WrappedComponent {...(otherProps as T)} />
      </Provider>
    );
  };

  Output.displayName = `withRedux(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Output;
}
